import { render, staticRenderFns } from "./ModalProgramGroupUserForm.vue?vue&type=template&id=9145e46e&scoped=true"
import script from "./ModalProgramGroupUserForm.vue?vue&type=script&lang=js"
export * from "./ModalProgramGroupUserForm.vue?vue&type=script&lang=js"
import style0 from "./ModalProgramGroupUserForm.vue?vue&type=style&index=0&id=9145e46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9145e46e",
  null
  
)

export default component.exports